import React from 'react';
import { Course } from '../../types/course';
import CourseCard from '../course/CourseCard';
import CourseCardSkeleton from '../common/CourseCardSkeleton';

interface SuggestedCoursesCarouselProps {
  courses: Course[];
  loading?: boolean;
}

const SuggestedCoursesCarousel: React.FC<SuggestedCoursesCarouselProps> = ({
  courses,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="mx-auto grid max-w-6xl grid-cols-1 justify-items-center gap-4 min-[480px]:grid-cols-2 sm:gap-5 lg:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="w-full max-w-[22rem]">
            <CourseCardSkeleton />
          </div>
        ))}
      </div>
    );
  }

  if (courses.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-green-900/60 lg:text-right">لا توجد كورسات مقترحة حالياً</p>
    );
  }

  return (
    <div className="mx-auto grid max-w-6xl grid-cols-1 justify-items-center gap-4 min-[480px]:grid-cols-2 sm:gap-5 lg:grid-cols-3">
      {courses.map((course) => (
        <CourseCard key={course.id} course={course} compact />
      ))}
    </div>
  );
};

export default SuggestedCoursesCarousel;
